import { Box, CircularProgress, Typography, Button } from '@mui/material';
import { useEffect, useState } from 'react';
import useApi from 'hooks/useApi';

// ==============================|| AI SUPPORT ||============================== //

const AiSupport = () => {
  const { getSoftwareIssuesEmbedUrl, showToast } = useApi();
  const [iframeUrl, setIframeUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const fetchEmbedUrl = async () => {
    setLoading(true);
    setError(false);
    try {
      const response = await getSoftwareIssuesEmbedUrl();
      if (response?.success && response?.data?.iframeUrl) {
        setIframeUrl(response.data.iframeUrl);
      } else {
        setError(true);
        showToast('Failed to load AI support', 'error');
      }
    } catch (err) {
      setError(true);
      showToast('Failed to load AI support', 'error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEmbedUrl();
  }, []);

  // The token this iframe uses expires (10 min) — refresh it before it goes
  // stale under a long-open tab instead of leaving the user with a dead embed.
  useEffect(() => {
    const interval = setInterval(fetchEmbedUrl, 8 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 60px)' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error || !iframeUrl) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 60px)', gap: 2 }}>
        <Typography variant="h6" color="text.secondary">
          Unable to load AI support
        </Typography>
        <Button variant="contained" onClick={fetchEmbedUrl}>
          Retry
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%', height: 'calc(100vh - 80px)' }}>
      <iframe
        src={iframeUrl}
        frameBorder="0"
        width="100%"
        height="100%"
        allowTransparency
        style={{ border: 'none', display: 'block' }}
        title="AI Support"
      />
    </Box>
  );
};

export default AiSupport;
